const Template = `
<div class="left-menu-modems">
  <ag-grid-vue
    class="ag-theme-balham-dark ag-theme-rtube left-menu-modems__top"
    :columnDefs="fields"
    :rowData="transformedModemRows"
    pagination="true"
    :paginationPageSize="perPage"
    rowSelection="single"
    @first-data-rendered="onFirstDataRendered"
    @grid-ready="onGridReady"
    @selection-changed="onModemChanged">
  </ag-grid-vue>
</div>`;

export { Template };



// WEBPACK FOOTER //
// ./src/app/js/components/onewire/left_menu/template.js